import { render, staticRenderFns } from "./NewChatModal.vue?vue&type=template&id=92fa7778&scoped=true&"
import script from "./NewChatModal.vue?vue&type=script&lang=js&"
export * from "./NewChatModal.vue?vue&type=script&lang=js&"
import style0 from "./NewChatModal.vue?vue&type=style&index=0&id=92fa7778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fa7778",
  null
  
)

export default component.exports